import { CONFIGURE_STRIPE_WIDGET } from '../../actions/stripe';

const updateStripeConfig = (config, data) => {
  const updatedConfig = config;
  const existingConfig = updatedConfig.findIndex(({ id }) => id === data.id);
  if (existingConfig === -1) {
    updatedConfig.push(data);
  } else {
    updatedConfig[existingConfig] = data;
  }
  return updatedConfig;
};

export const initialState = [];

export default (state = initialState, { type, data }) => {
  switch (type) {
    case CONFIGURE_STRIPE_WIDGET:
      return updateStripeConfig(state, data);
    default:
      return state;
  }
};
